import { IDirectOrder } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { DirectOrderDB } from 'src/app/common/repository/databases';
import { MessagePayloadType } from 'src/app/shared/models/share/message-payload-type';

import { IRouteParser } from '../contracts/route/route-parser';
import { QueryService } from '../query/query.service';
import { MessagePayloadCrossTherapy } from './../../models/share/message-payload-cross-therapy';

@Injectable()
export class CrossTherapyRouteParser implements IRouteParser {
  type = MessagePayloadType.CrossTherapy;

  constructor(private _queryService: QueryService) {}
  async parse(payload: MessagePayloadCrossTherapy): Promise<string> {
    const order: IDirectOrder = await this._queryService.get(payload.directOrderId, DirectOrderDB);

    if (!order) {
      throw new Error(`No direct order found for id ${payload.directOrderId}`);
    }

    return `/patient/${order.patientId}/crossTherapy/${order._id}`;
  }
}
